import {
    getAllScenario,
    addScenario,
    deleteScenario,
    get2040splitPercentages,
    getForecastVolumeAdjustments,
    saveFinalPostings,
    getOutFleetReDelivery,
    getOutFleetLost,
    getOutFleetSold,
    saveOutFleetReDelivery,
    saveOutFleetLost,
    saveOutFleetSold,
    saveInfleet,
    calculateTurnTime,
    getStocks,
    saveStocks,
    getInfleet,
    getPurchaseLease,
    savePurchaseLease,
    getInfleetLegacy,
    saveTurnTimePosting,
    getBhUtilization,
    view2040splitPercentages,
    viewForecastVolumeAdjustments,
    viewOutfleetLostDetails,
    viewOutfleetSoldDetails,
    viewOutfleetReDeliveryDetails,
    viewTurnTimePosting,
    getPurchaseLeasePerc,
    viewPurchaseLeasePerc,
    viewPurchaseLeaseVol,
    viewInfleet,
    getSEPEvaluation,
    getPurchaseLeasePercClone,
    summaryOutfleetLost,
    summaryOutfleetSold,
    summaryOutfleetReDelivery,
    getActualVsForecastInfleet,
    getActualVsForecastVolume,
    getYearWiseSplitVols,
    getTTAvgYearMonth,
    getTTAvgContainerTypeSplit,
    viewTTContainerSplit,
    getAllUsers,
    addUsers,
    editUser,
    deleteUsers,
    registerUser,
    getAllUsersToBeApproved,
    authorizeUser,
    publishScenario,
    approveUser,
    chatBot,
    saveUserActivity,
    viewPurchaseLeaseVolNew,
    getPurchaseLeaseVol,
    getCombinedExcelDownload,
} from "@/config/apiEndPoints";

    const getAllScenarioDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getAllScenario}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data : requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
  };


    const getBhUtilizationDetails = async (year, idToken) => {
        return {
            method: "get",
            url: `${getBhUtilization}`+`${year}`,
            headers: {
                Authorization: `Bearer ${idToken}`,
                Accept: "application/json",
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
            },
            validateStatus(status) {
                return status >= 200 && status < 300 || status === 500 || status === 400
            }
        };
    };

const getSEPEvaluationDetails = async (year, idToken) => {
    return {
        method: "get",
        url: `${getSEPEvaluation}`+`${year}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};



  const addScenarioDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${addScenario}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
  };

    const deleteScenarioDetails = async (requestData, idToken) => {
        return {
            method: "post",
            url: `${deleteScenario}`,
            headers: {
                Authorization: `Bearer ${idToken}`,
                Accept: "application/json",
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
            },
            data: requestData,
            validateStatus(status) {
                return status >= 200 && status < 300 || status === 500 || status === 400
            }
        };
    };

    const getOutFleetReDeliveryDetails = async (requestData, idToken) => {
        return {
            method: "post",
            url: `${getOutFleetReDelivery}`,
            headers: {
                Authorization: `Bearer ${idToken}`,
                Accept: "application/json",
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
            },
            data: requestData,
            validateStatus(status) {
                return status >= 200 && status < 300 || status === 500 || status === 400
            }
        };
    };

const getOutFleetLostDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getOutFleetLost}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const getOutFleetSoldDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getOutFleetSold}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const saveOutFleetReDeliveryDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${saveOutFleetReDelivery}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const saveOutFleetLostDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${saveOutFleetLost}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const saveOutFleetSoldDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${saveOutFleetSold}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const saveInfleetDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${saveInfleet}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};



    const get2040splitPercentagesDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${get2040splitPercentages}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

    const getForecastVolumeAdjustmentsDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getForecastVolumeAdjustments}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

    const saveFinalPostingsDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${saveFinalPostings}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
            }
        };
    };

const calculateTurnTimeDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${calculateTurnTime}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const getStocksDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getStocks}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const saveStocksDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${saveStocks}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const getInfleetDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getInfleet}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};


const getPurchaseLeaseDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getPurchaseLease}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const savePurchaseLeaseDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${savePurchaseLease}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const getInfleetLegacyDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getInfleetLegacy}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const saveTurnTimePostingDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${saveTurnTimePosting}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

// View

const view2040splitPercentagesDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${view2040splitPercentages}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const viewForecastVolumeAdjustmentsDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${viewForecastVolumeAdjustments}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const viewOutFleetLostDetailsList = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${viewOutfleetLostDetails}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const viewOutFleetSoldDetailsList = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${viewOutfleetSoldDetails}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const viewOutFleetReDeliveryDetailsList = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${viewOutfleetReDeliveryDetails}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const viewTurnTimePostingDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${viewTurnTimePosting}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const viewPurchaseLeasePercDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${viewPurchaseLeasePerc}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const viewPurchaseLeaseVolDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${viewPurchaseLeaseVol}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const viewInfleetDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${viewInfleet}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const getPurchaseLeasePercDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getPurchaseLeasePerc}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const getPurchaseLeasePercCloneDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getPurchaseLeasePercClone}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const summaryOutfleetLostDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${summaryOutfleetLost}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const summaryOutfleetSoldDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${summaryOutfleetSold}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const summaryOutfleetReDeliveryDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${summaryOutfleetReDelivery}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const getActualVsForecastInfleetDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getActualVsForecastInfleet}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const getActualVsForecastVolumeDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getActualVsForecastVolume}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const getYearWiseSplitVolsDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getYearWiseSplitVols}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const getTTAvgYearMonthDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getTTAvgYearMonth}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const getTTAvgContainerTypeSplitDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getTTAvgContainerTypeSplit}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};


const viewTTContainerSplitDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${viewTTContainerSplit}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const getAllUsersList = async (idToken,userEmail) => {
    return {
        method: "get",
        url: `${getAllUsers}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        },
        data : userEmail,
        validateStatus: function (status) {
            return status >= 200 && status < 300 || status === 409 || status == 400 || status == 500 || status == 401; // only accept success responses and 409 conflict error
        },

    };
}

const addUsersList = async (userEmail,idToken) => {
    return {
        method: "post",
        url: `${addUsers}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        },
        validateStatus: function (status) {
            return status >= 200 && status < 300 || status === 409 || status == 400 || status == 500 || status == 401; // only accept success responses and 409 conflict error
        },
        data : userEmail
    };
}

const editUserList = async (userEmail,idToken) => {
    return {
        method: "post",
        url: `${editUser}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        },
        validateStatus: function (status) {
            return status >= 200 && status < 300 || status === 409 || status == 400 || status == 500 || status == 401; // only accept success responses and 409 conflict error
        },
        data : userEmail
    };
}

const deleteUsersList = async (userEmail,idToken) => {
    return {
        method: "post",
        url: `${deleteUsers}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        },
        data : userEmail,
        validateStatus(status){
            return status >= 200 && status < 300 || status == 500 || status == 400 || status == 401
        },
    };
}

const authorizeUserList = async (userEmail,idToken) => {
    return {
        method: "post",
        url: `${authorizeUser}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        },
        validateStatus: function (status) {
            return status >= 200 && status < 300 || status === 401 ; // only accept success responses and 409 conflict error
        },
        data : userEmail
    };
}

const registerUserOnApp = async (userEmail, idToken) => {
    return {
        method: "post",
        url: `${registerUser}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        },
        validateStatus: function (status) {
            return status >= 200 && status < 300 || status === 409|| status == 400 || status == 500 || status == 401; // only accept success responses and 409 conflict error
        },
        data: userEmail
    };
}

const getAllUsersToBeApprovedList = async (idToken) => {
    return {
        method: "get",
        url: `${getAllUsersToBeApproved}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        },
        data: null,
        validateStatus(status){
            return status >= 200 && status < 300 || status == 500 || status == 400 || status == 401
        },
    };
}

const publishScenarioDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${publishScenario}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const approveUserRequest = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${approveUser}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const chatBotDetails = async (userEmail, idToken) => {
    return {
        method: "post",
        url: `${chatBot}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        },
        validateStatus: function (status) {
            return status >= 200 && status < 300 || status === 409|| status == 400 || status == 500 || status == 401; // only accept success responses and 409 conflict error
        },
        data: userEmail
    };
}

const saveUserActivityDetails = async (userEmail, idToken) => {
    return {
        method: "post",
        url: `${saveUserActivity}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        },
        validateStatus: function (status) {
            return status >= 200 && status < 300 || status === 409|| status == 400 || status == 500 || status == 401; // only accept success responses and 409 conflict error
        },
        data: userEmail
    };
}

const viewPurchaseLeaseVolNewDetails = async (userEmail, idToken) => {
    return {
        method: "post",
        url: `${viewPurchaseLeaseVolNew}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        },
        validateStatus: function (status) {
            return status >= 200 && status < 300 || status === 409|| status == 400 || status == 500 || status == 401; // only accept success responses and 409 conflict error
        },
        data: userEmail
    };
}

const getPurchaseLeaseVolDetails = async (userEmail, idToken) => {
    return {
        method: "post",
        url: `${getPurchaseLeaseVol}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        },
        validateStatus: function (status) {
            return status >= 200 && status < 300 || status === 409|| status == 400 || status == 500 || status == 401; // only accept success responses and 409 conflict error
        },
        data: userEmail
    };
}

const getCombinedExcelDownloadDetails = async (userEmail, idToken) => {
    return {
        method: "post",
        url: `${getCombinedExcelDownload}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        },
        validateStatus: function (status) {
            return status >= 200 && status < 300 || status === 409|| status == 400 || status == 500 || status == 401; // only accept success responses and 409 conflict error
        },
        data: userEmail
    };
}



export default {
    getAllScenarioDetails,
    getBhUtilizationDetails,
    addScenarioDetails,
    deleteScenarioDetails,
    get2040splitPercentagesDetails,
    getForecastVolumeAdjustmentsDetails,
    saveFinalPostingsDetails,
    getOutFleetReDeliveryDetails,
    getOutFleetLostDetails,
    getOutFleetSoldDetails,
    saveOutFleetReDeliveryDetails,
    saveOutFleetLostDetails,
    saveOutFleetSoldDetails,
    saveInfleetDetails,
    calculateTurnTimeDetails,
    getStocksDetails,
    saveStocksDetails,
    getInfleetDetails,
    getPurchaseLeaseDetails,
    savePurchaseLeaseDetails,
    getInfleetLegacyDetails,
    saveTurnTimePostingDetails,
    view2040splitPercentagesDetails,
    viewForecastVolumeAdjustmentsDetails,
    viewOutFleetLostDetailsList,
    viewOutFleetSoldDetailsList,
    viewOutFleetReDeliveryDetailsList,
    viewTurnTimePostingDetails,
    viewPurchaseLeaseVolDetails,
    viewPurchaseLeasePercDetails,
    viewInfleetDetails,
    getSEPEvaluationDetails,
    getPurchaseLeasePercDetails,
    getPurchaseLeasePercCloneDetails,
    summaryOutfleetLostDetails,
    summaryOutfleetSoldDetails,
    summaryOutfleetReDeliveryDetails,
    getActualVsForecastInfleetDetails,
    getActualVsForecastVolumeDetails,
    getTTAvgYearMonthDetails,
    getYearWiseSplitVolsDetails,
    getTTAvgContainerTypeSplitDetails,
    viewTTContainerSplitDetails,
    getAllUsersList,
    addUsersList,
    deleteUsersList,
    editUserList,
    authorizeUserList,
    registerUserOnApp,
    getAllUsersToBeApprovedList,
    approveUserRequest,
    publishScenarioDetails,
    chatBotDetails,
    saveUserActivityDetails,
    viewPurchaseLeaseVolNewDetails,
    getPurchaseLeaseVolDetails,
    getCombinedExcelDownloadDetails
};
